module.exports = __webpack_public_path__ + "img/celular.c9d8420f.png";